module.exports = __webpack_public_path__ + "static/media/AboutIcon02.24d7b44a.png";